import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { getRootStore } from "@/stores/RootStore";
import { observer } from "mobx-react-lite";
import { canEditDictionaries } from "@/utils/permissions";
import { canDeleteFromDictionaries } from "@/utils/permissions";
import { message, Modal, Skeleton, Card, Button, Flex } from "antd";
import styles from "@/styles/WorkShiftPage.module.less";
import { ArrowLeftOutlined, DeleteOutlined } from "@ant-design/icons";
import { WorkShiftForm } from "@/pages/WorkShifts/WorkShiftForm/WorkShiftForm";
export const WorkShiftPage = observer(() => {
    const navigate = useNavigate();
    const { shiftId } = useParams();
    const { singleWorkShiftStore: store, authStore: { userRole }, } = getRootStore();
    const { workShift, loading, technicianSelectStore } = store;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        store.init(shiftId);
        return () => {
            store.clearWorkShiftData();
        };
    }, [shiftId]);
    const handleBack = () => {
        navigate("/workshifts");
    };
    const handleSave = async (values) => {
        const isNewShift = !workShift;
        try {
            const savedShift = await store.saveWorkShift(values);
            if (savedShift) {
                if (isNewShift) {
                    message.success("Смена успешно создана");
                    navigate(`/workshifts/${savedShift.id}`);
                }
                else {
                    message.success("Смена успешно обновлена");
                }
            }
        }
        catch (error) {
            // Error handling is done in the store
        }
    };
    const handleDeleteShift = () => {
        if (!workShift)
            return;
        Modal.confirm({
            title: "Удаление смены",
            content: "Вы уверены, что хотите удалить эту смену?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: async () => {
                try {
                    await store.deleteWorkShift(workShift.id);
                    message.success("Смена успешно удалена");
                    navigate("/workshifts");
                }
                catch (error) {
                    // Error handling is done in the store
                }
            },
        });
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return (_jsxs(Flex, { vertical: true, gap: "large", className: styles.container, children: [_jsx("div", { className: styles.backButtonContainer, children: _jsx(Button, { icon: _jsx(ArrowLeftOutlined, {}), onClick: handleBack, type: "text", className: styles.backButton, children: "\u041D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443 \u0441\u043C\u0435\u043D" }) }), _jsx(WorkShiftForm, { workShift: workShift, loading: loading, onSubmit: handleSave, onCancel: handleBack, disabled: !canEdit, technicianSelectStore: technicianSelectStore, extraButtons: canDelete && workShift ? (_jsx(Button, { type: "default", danger: true, icon: _jsx(DeleteOutlined, {}), onClick: handleDeleteShift, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })) : undefined })] }));
});
export default WorkShiftPage;
